import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import Field from './field';

const isReallyEmpty = (value) => _.isUndefined(value) || _.isNull(value);

class TypeaheadField extends Field {
	renderInput () {
		const { fieldKey, collection, dataId, store, optionsStore, formStore } = this.props;
		const { injectOptions, options, valueKey } = formStore.get(fieldKey);
		const isPossessive = false;

		console.log('[optionsStore]', optionsStore);

		const injectedOptions = formStore.getInjectOptions({
			dataStore: optionsStore || store,
			injectOptions: injectOptions
		});

		let value;

		if (_.isEmpty(dataId)) {

			value = _.get(store.data, fieldKey);
		} else {

			const key = fieldKey.replace(/^\w+\./, '');
			value = store.items[store.getItemIndex({ id: dataId })][key];
		}

		if (valueKey && isReallyEmpty(value)) {

			value = store.get(valueKey);
		}

		if (_.isEmpty(value) || _.isString(value)) {

			value = {
				label: ''
			};
		}

		console.log('[optionsStore.options]', optionsStore.options);

		return (
			<div>
				<AsyncTypeahead
					labelKey="label"
					defaultSelected={ [value] }
					options={ optionsStore.options }
					onSearch={ this.onSearch }
					onChange={ this.onChange } />
			</div>
		);
	}

	@autobind
	async onSearch (search) {
		const results = await this.props.optionsStore.search(search);
	}

	@autobind
	onChange (value) {
		console.log('[onChange - value]', value);
		// Make the arg look like an event object with a target
		this.handleChange({
			target: { value: _.first(value) }
		});
	}
}

export default TypeaheadField;
